<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Postcards</h1>
      <div class="text-large">So many choices.</div>
    </div>
  </div>
<Printables Category="postcards" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Printables from "@/components/PrintableCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Printables
  }
};
</script>
